import React, { useState } from 'react'
import { randomKey } from 'utils/functions'
import { APPLICATION_RESULT_DESCRIPTION } from 'utils/constants/application'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from '@mui/material'
import { Button, Modal } from 'components'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandedInfo from 'components/ExpandedInfo'
import Colors from 'utils/Colors'
import Container from './styles'

function ApplicationInfo(props) {
  const { check, review } = props

  
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedAppId, setSelectedAppId] = useState('')
  
  const handleOpenModal = (appId) => {
    setSelectedAppId(appId)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setSelectedAppId(null)
    setModalOpen(false)
  }


  const buildStatusInfo = (status) => {
    const defaultStatus = 'Em andamento'
    const statusDescription = APPLICATION_RESULT_DESCRIPTION[status] || defaultStatus
  
    const statusColors = {
      [APPLICATION_RESULT_DESCRIPTION.approved]: Colors.approvedGreen,
      [APPLICATION_RESULT_DESCRIPTION.reproved]: Colors.reprovedRed,
      default: Colors.ongoing,
    }
  
    const color = statusColors[statusDescription] || statusColors.default
    return (
      <span style={{ color: color }}>{statusDescription}</span>
    )
  }

  const buildGreenhouseStatusInfo = (status) => {
    const statusDictionary = {
      'active': 'Active',
      'rejected': 'Rejected',
      'hired': 'Hired',
      default: "Dados indisponíveis",
    }
    
    const statusDescription = statusDictionary[status]
    const statusColors = {
      [statusDictionary.active]: Colors.ongoing,
      [statusDictionary.hired]: Colors.approvedGreen,
      [statusDictionary.rejected]: Colors.reprovedRed,
      default: Colors.gray,
    }
  
    const color = statusColors[statusDescription] || statusColors.default
  
    return (
      <span style={{ color }}>{statusDescription}</span>
    )
  }

  const filterApplicationsWithScoreReviews = () => {
    const applications = check?.applications

    if (!applications) {
      return []
    }
    
    if (review.review_type !== 'score_board') {
      return applications
    }
    return applications.filter(app => app.score_board_uuid === review?.score_board?.uuid)
  }

  const applications = filterApplicationsWithScoreReviews()
  return (
    applications && (
      <React.Fragment>
        <Accordion title="Aplicações envolvidas">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h4>{`Aplicações Envolvidas (${applications.length})`}</h4>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {applications.map((app) => (
                <Grid item key={randomKey('app-grid')}>
                  <Container>
                    <p>
                      <span>ID da Greenhouse: </span>
                      {app.greenhouse_id}
                    </p>
                    <p className="name">
                      <span>Área de Ocupação: </span>
                      {app.occupation_area}
                    </p>
                    <p>
                      <span>Cargo: </span>
                      {app.job_role}
                    </p>
                    <p>
                      <span>Recrutador: </span>
                      {app.candidate?.recruiter_name || 'Informação indisponível'}
                    </p>
                    <p>
                      <span>Status: </span>
                      {buildStatusInfo(app.status)}
                    </p>          
                    <p>
                      <span>Contratação Greenhouse: </span>
                      {buildGreenhouseStatusInfo(app.greenhouse_status)}
                    </p>                            
                    <br></br>
                    <Button onClick={() => handleOpenModal(app.uuid)}>
                      Mais Detalhes
                    </Button>
                  </Container>
                </Grid>
              ))}
            </Grid>
          </AccordionDetails>
        </Accordion>

        {selectedAppId && (
          <Modal
            open={modalOpen}
            onClose={handleCloseModal}
            title="Informações detalhadas da aplicação"
          >
            <ExpandedInfo
              handleClose={handleCloseModal}
              application_id={selectedAppId}
            />
          </Modal>
        )}
      </React.Fragment>
    )
  )
}

export default ApplicationInfo
